<template>
  <div class="articles-section py-4 py-md-6">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <div v-if="!loading && (items.length || highlightItem)">
        <v-container>
          <TitleWidget>Notícias</TitleWidget>
          <v-row
            class="mt-6 align-start"
            :class="items.length < 3 ? `align-lg-start` : `align-lg-center`"
          >
            <v-col cols="12" md="7">
              <ArticlesHighlightCard :item="highlightItem" />
            </v-col>
            <v-col cols="12" md="5">
              <template v-for="(item, i) in items">
                <ArticlesCard :key="i" v-bind="item" />
              </template>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import LoadingWidget from "../widgets/LoadingWidget.vue";
import { formatDate } from "../../utils/formatDate";
import ArticlesCard from "../cards/ArticlesCard.vue";
import ArticlesHighlightCard from "../cards/ArticlesHighlightCard.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

const _config = {
  mod: "articles",
};
export default {
  data: () => ({
    loading: true,
    items: [],
    highlightItem: {},
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getArticles() {
      const params = { highlight: 1, itemsPerPage: 4 };
      this.$rest(_config.mod)
        .get({ params })
        .then((articles) => {
          const items = articles.map(({ title, img, createdAt, id }) => ({
            id,
            title,
            img: this.files + img,
            date: this.xsOnly
              ? formatDate(createdAt, "long").replaceAll(" de ", " ")
              : formatDate(createdAt, "long"),
            to: `/noticias/${formatToURL(title)}-${id}`,
          }));
          this.highlightItem = items.shift();
          this.items = items;
        })
        .then(() => (this.loading = false));
    },
  },
  mounted() {
    this.getArticles();
  },
  components: {
    LoadingWidget,
    ArticlesCard,
    ArticlesHighlightCard,
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped></style>
